module.exports = __webpack_public_path__ + "assets/img/right_3.86b82f62.png";